// Trigger git update
// Shared plan utilities for consistent plan information across the app

export const getPlanFeatures = (planType) => {
  const plans = {
    free: {
      name: 'Free Plan',
      features: [
        '1 Domain Monitoring',
        'MX Record & Email Analysis',
        'Advanced Risk Scoring',
        'SSL & Certificate Inspection',
        'On-Demand Scanning',
        'Basic Email Alerts',
        'Community Support'
      ],
      limitations: [
        'Manual scans only',
        'No scheduled scanning',
        'No API access',
        'Limited to 1 domain'
      ],
      price: 'Free',
      color: 'text-gray-800',
      bgColor: 'bg-gray-100'
    },
    pro: {
      name: 'Pro Plan',
      price: 'Coming soon',
      color: 'text-blue-800',
      bgColor: 'bg-blue-100',
      features: [
        '10 Domain Capacity',
        'Automated Daily Scans',
        'MX Record & Email Analysis',
        'Advanced Risk Scoring',
        'SSL & Certificate Inspection',
        'Developer API Access',
        'Smart Whitelisting'
      ],
      limitations: [
        'Limited to 10 domains maximum'
      ]
    },
    enterprise: {
      name: 'Enterprise',
      features: [
        'Unlimited domains',
        'Custom scan schedules',
        'Admin user management',
        'Custom reporting',
        'Dedicated support',
        'SLA guarantees'
      ],
      limitations: [
        'Contact sales for pricing',
        'Advanced integrations in development'
      ],
      price: 'Coming soon',
      color: 'text-purple-800',
      bgColor: 'bg-purple-100'
    }
  };

  return plans[planType] || plans.free;
};

// Unified plan data for pricing section and user plan display
export const getAllPlans = () => {
  return [
    {
      ...getPlanFeatures('free'),
      key: 'free',
      name: 'Free',
      price: '$0',
      period: 'forever',
      features: [
        '1 Domain Monitoring',
        'MX Record & Email Analysis',
        'Advanced Risk Scoring',
        'SSL & Certificate Inspection',
        'On-Demand Scanning',
        'Basic Email Alerts',
        'Community Support'
      ],
      cta: 'Start Free Scan',
      popular: false
    },
    {
      ...getPlanFeatures('pro'),
      key: 'pro',
      name: 'Pro',
      price: '5',
      currency: 'CHF',
      period: 'per month',
      features: [
        '10 Domain Capacity',
        'Automated Daily Scans',
        'MX Record & Email Analysis',
        'Advanced Risk Scoring',
        'SSL & Certificate Inspection',
        'Developer API Access',
        'Smart Whitelisting'
      ],
      cta: 'Upgrade to Pro',
      popular: true
    },
    {
      ...getPlanFeatures('enterprise'),
      key: 'enterprise',
      name: 'Enterprise',
      price: 'Custom',
      period: 'per month',
      features: [
        'Unlimited domains',
        'Custom scan schedules',
        'Admin user management',
        'Custom reporting',
        'Dedicated support',
        'SLA guarantees'
      ],
      cta: 'Contact Sales',
      popular: false
    }
  ];
};
